import { preprocess } from '@artica/assets';
import fog from '../common/fog';
import {
  Color,
  MeshStandardMaterial,
} from 'three';

preprocess('obsidian_fg_terrain', function preprocessObsidian(asset) {
  const { materials } = asset;

  materials.principledshader1.color = new Color(1, 1, 1);

  materials.principledshader1 = new MeshStandardMaterial({
    map: materials.principledshader1.map,
  });

  for (const key in materials) {
    const material = materials[key];

    material.reflectivity = 0.1;
    material.metalness = 0;
    material.roughness = 1;
    material.specularIntensity = 0;
    material.ior = 1.1;
    material.color = new Color(0.2, 0.2, 0.2);

    fog(material);
  }

  return asset;
});